export enum EReportingPaymentStatus {
  Created = 'CREATED',
  Confirmed = 'CONFIRMED',
  Canceled = 'CANCELED',
  Refunded = 'REFUNDED',
  Scheduled = 'SCHEDULED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

export type TReportingPaymentsReqParams = {
  asset_issuers?: string[];
  guids?: string[];
  asset_codes?: string[];
  sender_ids?: string[];
  receiver_ids?: string[];
  statuses?: EReportingPaymentStatus[] | string[];
  min_amount?: string;
  max_amount?: string;
  min_created_at?: string | null;
  max_created_at?: string | null;
  sender_counterparty?: string;
  receiver_counterparty?: string;
  sender_branch?: string;
  receiver_branch?: string;
  limit?: number;
  offset?: number;
  order?: string;
  sender_acc_kinds?: string[];
  receiver_acc_kinds?: string[];
};

export type TReportingPaymentsEntity = {
  amount: number;
  asset_code: string;
  asset_issuer: string;
  created_at: string;
  deleted_at: string;
  guid: string;
  receiver_id: string;
  sender_id: string;
  status: EReportingPaymentStatus;
  updated_at: string;
  sender_counterparty: string;
  receiver_counterparty: string;
  receiver_account_account_kind: string;
  sender_account_account_kind: string;
  fee: number;
};

export type TReportingPaymentsResData = {
  payments: TReportingPaymentsEntity[];
  total: number;
};
